










































  import { obtenirInformationsNavigateur } from '@/commun/utils/navigateur-utils';
  import Vue from 'vue';

  export default Vue.extend({
    name: 'DialogueErreur',
    props: {
      value: {
        type: Boolean,
        default: false,
      },
      erreur: {
        type: Error,
        required: false,
        default: undefined,
      },
    },
    computed: {
      informationsNavigateur(): string {
        return obtenirInformationsNavigateur().toString();
      },
    },
    methods: {
      onFermer() {
        this.$emit('input', false);
      },
      onInput(valeur: boolean) {
        this.$emit('input', valeur);
      },
    },
  });
